import { MouseEventHandler } from 'react';
import twMerge from 'utils/twMerge';

type SortingBarItemProps = { isActive: boolean; href?: string; onClick?: () => void };

export const SortingBarItem: FC<SortingBarItemProps> = ({ children, isActive, href, onClick }) => {
    const handleOnClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.preventDefault();

        if (onClick) {
            onClick();
        }
    };

    return (
        <a
            tabIndex={0}
            href={href}
            className={twMerge(
                'block p-3 text-center text-tiny font-medium text-white no-underline transition hover:no-underline vl:py-2 vl:px-0 vl:text-body vl:text-black vl:hover:text-green',
                isActive &&
                    'hover:text-pointer-events-none hidden cursor-default vl:block vl:border-b vl:border-green vl:text-green',
            )}
            onClick={handleOnClick}
        >
            {children}
        </a>
    );
};
